<template>
  <span
    class="
        badge
        rounded-circle
        bg-dark
        text-white
      "
  >
    <slot />
  </span>
</template>

<script>
export default {
  name: 'Pills'
}
</script>

<style scoped>

</style>
